import { CreateCompanyDocumentConfirmationInModal } from "../features/create-company-document-confirmation";
import { CreateCompanyDocumentConfirmationForActivePersonsAsButton } from "../features/create-company-document-confirmation-for-active-persons";
import { useTranslations } from "use-intl";
import { AddButtonGroup } from "@/shared/form/button/add-button-group/add-button-group";

export function CreateCompanyDocumentConfirmationMenu({
  documentId,
}: {
  documentId: string;
}) {
  const t = useTranslations("Documents");

  return (
    <AddButtonGroup
      buttonProps={{
        children: t("Add participants"),
      }}
      popoverProps={{
        content: (
          <>
            <CreateCompanyDocumentConfirmationInModal
              triggerProps={{
                variant: "text",
                color: "primary",
              }}
              documentId={documentId}
            />
            <CreateCompanyDocumentConfirmationForActivePersonsAsButton
              documentId={documentId}
              buttonProps={{
                variant: "text",
                color: "primary",
              }}
            />
          </>
        ),
      }}
    />
  );
}
